module.exports = __webpack_public_path__ + "static/media/Team.147d7ad4.png";